"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockCart = void 0;
var mockCart = [{
  MenuItemId: 'MTO-14CP',
  itemId: 102000,
  maxToppings: 40,
  Quantity: 1,
  selectedCrust: 'Round',
  selectedToppings: [],
  selectedCustomOptions: [{
    id: 'B',
    title: 'Bake',
    options: [{
      value: 'Normal Bake',
      isSelected: true,
      optionId: 1
    }]
  }, {
    id: 'C',
    title: 'Cheese',
    options: [{
      value: 'Cheese',
      isSelected: true,
      optionId: 1
    }]
  }, {
    id: 'S',
    title: 'Sauce',
    options: [{
      value: 'Normal Sauce',
      isSelected: true,
      optionId: 2
    }]
  }, {
    id: 'CO',
    title: 'Cut Option',
    options: [{
      value: 'Standard Cut',
      isSelected: true,
      optionId: 1
    }]
  }]
}];
exports.mockCart = mockCart;